import React, { type FC } from 'react'
import { Backdrop, CircularProgress } from '@mui/material'
import { useAppSelector } from '../../../redux/hooks'
import { type RootState } from '../../../redux/store'

export const Spinner: FC = () => {
  const authLoading = useAppSelector((state: RootState) => state.auth.loading)
  const metersLoading = useAppSelector((state: RootState) => state.meterTable.loading)
  const noticesLoading = useAppSelector((state: RootState) => state.notices.loading)
  const loading = (): boolean =>
    authLoading > 0 ||
        metersLoading > 0 ||
        noticesLoading > 0

  return (
        <Backdrop sx={{ backgroundColor: 'rgba(255, 255, 255, .5)' }} open={loading()} data-testid='loading-spinner'>
            <CircularProgress color='primary'></CircularProgress>
        </Backdrop>
  )
}
